class AwardWinningSake extends HTMLElement {
  constructor(){
    super();
    this.init();
  }
  init(){
    if(Swiper){
      this.swiper = new Swiper(this.querySelector('.award__slider'), {
          slidesPerView: 7,
          spaceBetween: 15,
          // loop: true,
          // autoplay: {
          //   delay: 4500,
          //   disableOnInteraction: false,
          // },
          breakpoints: {
            0: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            768: {
              slidesPerView: 5,
              spaceBetween: 15,
            },
            1024: {
              slidesPerView: 6,
              spaceBetween: 15,
            },
            1200:{
              slidesPerView: 7,
              spaceBetween: 15,
            }
          },
          // centeredSlides: true,
      });
    }
  }
}
 
if(!customElements.get('award-winning-sake')){
  customElements.define('award-winning-sake', AwardWinningSake);
}
class FeaturedSakeSlide extends HTMLElement {
  constructor(){
    super();
    this.init();
  }
  init(){    
    if(Swiper){
      this.swiper = new Swiper(this.querySelector('.feature__sake-slider'), {
          slidesPerView: 3,
          spaceBetween: 32,
          loop: true,
          autoplay: {
            delay: 2500,
            disableOnInteraction: false,
          },          
          breakpoints: {
            0: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            820:{
              slidesPerView: 3,
              spaceBetween: 32,
            },          
            1024: {
              slidesPerView: 3,
              spaceBetween: 32,
            }            
          },
          // centeredSlides: true,
      });
    }
  }
}
 
if(!customElements.get('featured-sake-slide')){
  customElements.define('featured-sake-slide', FeaturedSakeSlide);
}
class TimelineSlider extends HTMLElement {
  constructor(){
      super();
      this.init();
  }
  init(){
      var swiper = new Swiper(this.querySelector(".mySwiper"), {
      loop: true,
      spaceBetween: 0,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
      1: {
          direction: 'vertical'
      },
      768: {
          loop: true,
          spaceBetween: 0,
          slidesPerView: 4,
          freeMode: true,
          watchSlidesProgress: true,
      }
      },
      });
      var swiper2 = new Swiper(this.querySelector(".mySwiper2"), {
      loop: true,
      spaceBetween: 10,
      navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
      },
      thumbs: {
          swiper: swiper,
      },
      });
  }
}
if(!customElements.get('time-line-slider')){
  customElements.define('time-line-slider', TimelineSlider);
}
// More recipies
class MoreRecipe extends HTMLElement {
  constructor(){
      super();
      this.init();
  }
  init(){
      if(Swiper){
          this.swiper = new Swiper(this.querySelector('.recipes__slide'), {
              slidesPerView: 3,
              spaceBetween: 20.5,
              loop: true,
              breakpoints: {
                  0: {
                      slidesPerView: 1,
                      spaceBetween: 20,
                  },
                  768: {
                      slidesPerView: 2,
                      spaceBetween: 20,
                  },
                  992: {
                      slidesPerView: 3,
                      spaceBetween: 20.5,
                  },
              },
              navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
              },
          });
      }
  }
}
if(!customElements.get('more-recipe')){
  customElements.define('more-recipe', MoreRecipe);
}
// custom contact form
class CustomContactForm extends HTMLElement {
  constructor() {
    super();
    this.submitBtn = this.querySelector('.submit_btn');
    this.inputFields = this.querySelectorAll('.form_field , .consent_box_1, .consent_box_2');
    this.errorBoxes = this.querySelectorAll('.error_box, .error_all_box');
  }

  connectedCallback() {
    if (!this.submitBtn) return;
    this.formSubmission();
    this.inputFieldsFunc();
  }

  inputFieldsFunc() {
    this.inputFields.forEach((field) => {
      let input = field.querySelector('input');
      let errorBox = field.querySelector('.error_box');

      if (!input || !errorBox) return;

      // Jab focus aaye → error hide
      input.addEventListener("focus", () => {
        errorBox.style.display = "none";
        errorBox.dataset.error = "false";
      });

      // REAL-TIME + FOCUSOUT VALIDATION
      input.addEventListener("input", () => this.validateField(input, errorBox));
      input.addEventListener("focusout", () => this.validateField(input, errorBox));
    });
  }

  validateField(input, errorBox) {
    let value = input.value.trim();
    let type = input.type;

    // EMPTY FIELD
    if (value === "") {
      errorBox.innerHTML = "Please complete this required field";
      errorBox.style.display = "block";
      errorBox.dataset.error = "true";
      return;
    }

    // TEL VALIDATION (LIVE)
    if (type === "tel") {
      let phoneRegex = /^\+?[0-9]{4,15}$/;

      if (!phoneRegex.test(value)) {
        if (value.length < 4) {
          errorBox.innerHTML = "Phone number is too short (min 4 digits)";
        } else if (value.length > 15) {
          errorBox.innerHTML = "Phone number is too long (max 15 digits)";
        } else {
          errorBox.innerHTML = "Please enter a valid phone number";
        }
        errorBox.style.display = "block";
        errorBox.dataset.error = "true";
        return;
      }
    }


    // EMAIL VALIDATION (LIVE)
    if (type === "email") {
      let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(value)) {
        errorBox.innerHTML = "Please enter a valid email address";
        errorBox.style.display = "block";
        errorBox.dataset.error = "true";
        return;
      }
    }

    // CHECKBOX VALIDATION
    if (type === "checkbox") {
      if (!input.checked) {
        errorBox.innerHTML = "Please complete this required field";
        errorBox.style.display = "block";
        errorBox.dataset.error = "true";
        return;
      }
    }

    // ALL GOOD → HIDE ERROR
    errorBox.style.display = "none";
    errorBox.dataset.error = "false";
  }

  formSubmission() {
    this.submitBtn.addEventListener("click", (e) => {    
      e.preventDefault();

      let hasError = false;

      this.inputFields.forEach((field) => {
        let input = field.querySelector("input");
        let errorBox = field.querySelector(".error_box");

        if (!input || !errorBox) return;

        // Validate field
        this.validateField(input, errorBox);

        // Check if field has error after validation
        if (errorBox.dataset.error === "true") {
          hasError = true;
        }
      });

      // SHOW .error_all_box ONLY if any error exists
      this.errorBoxes.forEach((box) => {
        if (box.classList.contains("error_all_box")) {
          if (hasError) {
            box.style.display = "block";
            box.dataset.error = "true";
          } else {
            box.style.display = "none";
            box.dataset.error = "false";
          }
        }
      });

      // IF NO ERROR → allow form submission (Shopify default)
      if (!hasError) {
        // Remove preventDefault to let Shopify handle submit
        e.target.closest("form")?.submit();
    }
  });
}
}

if (!customElements.get('custom-contact-form')) {
  customElements.define('custom-contact-form', CustomContactForm);
}

class FeaturedInSlider extends HTMLElement{
  constructor(){
      super();
      this.init();
  }
  init(){      
      this.swiper = new Swiper(this.querySelector('.mySwiperFeatured'), {
      slidesPerView:4,
      spaceBetween: 189,
      clickable: true ,
      // loop: true,
      // autoplay: {
      //   delay: 1500,
      //   disableOnInteraction: false,
      // },
      breakpoints: {
        0: {
            slidesPerView: 2,
            spaceBetween: 45,
        },
        768: {
            slidesPerView: 4,
            spaceBetween: 94.5,
        },
        1025: {
          slidesPerView: 4,
          spaceBetween: 94.5,
        }
      },

      });
  }
}
if(!customElements.get('featured-in-slider')){
    customElements.define('featured-in-slider', FeaturedInSlider);
}
class AnnouncementSlider extends HTMLElement{
  constructor(){
      super();
      this.init();
  }
  init(){      
      this.swiper = new Swiper(this.querySelector('.announcementSwiper'), {           
      clickable: true,
       pagination: {
        el:  document.querySelector('.announcement__pagination > .swiper-pagination'),
        clickable: true,
      },        
      
      });
  }
}
if(!customElements.get('announcement-slider')){
    customElements.define('announcement-slider', AnnouncementSlider);
}